<!-- 检测服务场景 -->
<template>
  <div class="adressServe">
    <h3 class="h3">服务场景</h3>
    <div class="addressCon width">
      <ul>
        <li
          :class="indexs==i?'active':''"
          @click="handle(i)"
          v-for="(item,i) in adressServe[0].titleBar"
          :key="i"
        >{{item.title}}</li>
      </ul>
      <div class="itemCon">
        <div class="itemConTop">
          <div class="topImg">
            <img :src="tabItem[0].imgurl" alt srcset />
          </div>
          <div class="topImgItem">
            <div class="item-item boxshadow" v-for="(item,i) in tabItem[0].addItem" :key="i">
              <div class="topImgItemTitle">{{item.title}}</div>
              <div class="topImgItemP">{{item.pp}}</div>
            </div>
          </div>
        </div>
        <div class="itemConBottom">
          <img :src="tabItem[0].bottomImg" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: { adressServe: Array },
  data() {
    return {
      indexs: 0,
      tabItem: [
        {
          imgurl: require('../assets/images/u1231.ca7d3313.png'),
          addItem: [{ id: 1, title: '微谱检测', pp: '想检测原料是否合格' }],
          bottomImg: require('../assets/images/u1235.da341ae3.png'),
        },
      ],
      tabItem1: [
        {
          imgurl: require('../assets/images/u1231.ca7d3313.png'),
          addItem: [{ id: 1, title: '微谱检测', pp: '想检测原料是否合格' }],
          bottomImg: require('../assets/images/u1235.da341ae3.png'),
        },
      ],
      tabItem2: [
        {
          imgurl: require('../assets/images/u1237.png'),
          addItem: [
            { id: 1, title: '原材料评价', pp: '想检测原料是否合格' },
            { id: 2, title: '配方分析', pp: '想生产需要配方分析' },
            { id: 3, title: '产品开发', pp: '想研发更优产品' },
            { id: 4, title: '性能改进', pp: '想提升产品性能，控制成本' },
            { id: 5, title: '工业诊断', pp: '想解决产品失效，异物等问题' },
          ],
          bottomImg: require('../assets/images/u1253.png'),
        },
      ],
      tabItem3: [
        {
          imgurl: require('../assets/images/u1255.png'),
          addItem: [
            { id: 1, title: '微谱检测', pp: '想检测产品是否合格' },
            { id: 2, title: '配方分析', pp: '想模仿生产产品' },
          ],
          bottomImg: require('../assets/images/u1262.png'),
        },
      ],
      tabItem4: [
        {
          imgurl: require('../assets/images/u1267.png'),
          addItem: [{ id: 1, title: '微谱检测', pp: '想检测产品是否合格' }],
          bottomImg: require('../assets/images/u1235.png'),
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handle(i) {
      this.indexs = i
      switch (i) {
        case 0:
          this.tabItem = this.tabItem1
          break
        case 1:
          this.tabItem = this.tabItem2
          break
        case 2:
          this.tabItem = this.tabItem3
          break
        case 3:
          this.tabItem = this.tabItem4
          break
        default:
          //这里是没有找到对应的值处理
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.adressServe {
  width: 100%;
  padding-bottom: 40px;
  margin-bottom: 10px;
  padding-top: 20px;
  margin-top: 10px;
  background: url('../assets/images/u213.png') 100% 100% no-repeat;
  background-size: cover;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    color: #fff;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .addressCon {
    text-align: center;
    ul {
      width: 520px;
      display: flex;
      color: #fff;
      margin: 0 auto 0 auto;
      li {
        flex: 1;
        font-size: 16px;
        line-height: 60px;
        cursor: pointer;
      }
      .active {
        color: #0078d7;
        border-top: 3px solid #0078d7;
      }
    }
    .itemCon {
      background-color: rgba(247, 248, 248, 1);
      border-radius: 4px;
      .itemConTop {
        display: flex;
        .topImg {
          flex: 1;
          margin: 10px;
          img {
            width: 100%;
            height: 366px;
          }
        }
        .topImgItem {
          flex: 2;
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;
          .item-item {
            width: 32.3%;
            box-sizing: border-box;
            height: 180px;
            margin-right: 1%;
            margin-bottom: 1%;
            background-color: rgba(242, 242, 242, 1);
            .topImgItemTitle {
              margin-top: 40px;
              margin-bottom: 30px;
              font-size: 16px;
            }
          }
        }
      }
      .itemConBottom {
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
